import { ApiEndpoints } from "@shared/api/api-endpoints";
import { consumerCommunicationApiClient } from "@shared/api/clients/apiClientFactory";

export const callCenterPerformanceApi = {
  getSummaryDashboard: async (remoteUtilityId: any, createdBy: any,year: number, month: number) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerCommunication",
      "consumer-summary-executive-dashboard",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("created_by", createdBy);
        query.push("year", year);
        query.push("month", month);
        query.push("filter_type", "monthly");
        return query;
      }
    );

    const response = await consumerCommunicationApiClient.get(url);
    return response.data.result ?? [];
  },

  getConsumerWeeklyReport: async (remoteUtilityId: any, createdBy: any) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerCommunication",
      "consumer-weekly-report",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("created_by", createdBy);
        return query;
      }
    );

    const response = await consumerCommunicationApiClient.get(url);
    return response.data.result ?? [];
  },
};
